<template>
    <settings-control label="Box Shadow">
        <dropdown
            theme="minimalistic"
            placeholder="Select One"
            :options="options"
            :value="value"
            native
            @input="onInput"
        />
    </settings-control>
</template>

<script>
import SettingsControl from '@/components/settings/shared/settings-control';
import { tailwindConfig } from '@/data/tailwind';
import mapFilters from '@/utils/map-filters';

const configValues = tailwindConfig.theme.boxShadow;

export default {
    name: 'settings-control-box-shadow',
    components: { SettingsControl },

    props: {
        value: {
            type: String,
            default: 'none',
        },
    },

    computed: {
        options() {
            return Object.keys(configValues).map(key => ({
                text: this.titleCase(key),
                value: configValues[key],
            }));
        },
    },

    methods: {
        ...mapFilters(['titleCase']),

        onInput(value) {
            this.$emit('input', {
                tailwindDefinitionProp: 'boxShadow',
                value,
            });
        },
    },
};
</script>
